import react, {useEffect,useState} from 'react';
import { message, Modal, Tooltip, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import copy from "copy-to-clipboard";
import storage from "./storage.js";
import Api from "../api";
import aiSourcePPt from "../assets/img/V7/aiSourcePPt.svg";
import aiSourceWord from "../assets/img/V7/aiSourceWord.svg"; 

const { confirm } = Modal;
let detailsLoading = false;
const { Text, Link } = Typography;

export const processingDataFormat = (html, id, className, sources) => {
    let newHtml = html;


    if(!sources || sources.length <= 0){
        return newHtml;
    }
    // <cite>[A0]</cite>
    // A代表来源类型
    // 0代表来源的位置

    const results = [...html.matchAll(/<cite>(.*?)<\/cite>/g)].map(match => match[1]);


    // 来源类型:
    {/* A:知识库文档 - sources
    B:公共知识库文档 - publicSources
    C:外部知识库文档 - exSources
    D:联网搜索文档 - webSources
    E:图片来源 */}
    results.map(item=>{

        let raw = "<cite>" + item + "</cite>";
    
        const matches = item.match(/\[(.*?)\]/g)?.map(m => m.slice(1, -1)) || [];
        // console.log(matches); // 输出：["D0", "D1", "D2", "D3"] 或 ["A0"]

        let htmlSin = "";
        matches.map(items => { 
            // 截取前1个字符
            let firstChar = items.substring(0, 1);

            // 截取剩下的字符
            let remainingStr = items.substring(1);

            if(remainingStr.includes('-')){
                remainingStr = remainingStr.split('-')[0];
            }

            if(firstChar === 'A' && sources && sources[remainingStr]){

                // 所有页码
                let pages = sources[remainingStr].pages;
                let docId = sources[remainingStr].docId;
                let policyId = sources[remainingStr].policyId;
                let knowledgeId = sources[remainingStr].knowledgeId;
                let fileType = sources[remainingStr].fileType;
                if(fileType === "xsl" || fileType === "xlsx" || fileType === "xlsm"){
                    pages.map(item => { 
                        // 知识库文档
                        htmlSin += '<span '+
                        'data-my-data='+id+
                        ' data-my-index='+remainingStr+ 
                        ' data-my-docId='+docId+
                        ' data-my-knowledgeId='+knowledgeId+
                        ' data-my-policyId='+policyId+
                        ' class="knowledgeSources '+className+' '+fileType+'">Excel</span>'
                    });
                }else{
                    pages.map(item => { 
                        // 知识库文档
                        htmlSin += '<span '+
                        'data-my-data='+id+
                        ' data-my-index='+remainingStr+ 
                        ' data-my-docId='+docId+
                        ' data-my-knowledgeId='+knowledgeId+
                        ' data-my-policyId='+policyId+
                        ' class="knowledgeSources '+className+' '+fileType+'">P'+
                        item+'</span>'
                    });
                }
            }
        });

        newHtml = newHtml.replace(raw, htmlSin)
    })
    
    return newHtml
}



function findSubstrings(str, startChar, endChar) {
    const regex = /##[^#]+?\$\$/g;
    const matches = str.match(regex) || [];
    return matches.map(match => match.substring(startChar.length, match.length - endChar.length));
}


export const  getQASourceIcon = (fileType) => { 
    const fileIcon = {
        docm: (<img src={aiSourceWord} alt=""/>),
        doc: (<img src={aiSourceWord} alt=""/>),
        docx: (<img src={aiSourceWord} alt=""/>),
        ppt: (<img src={aiSourcePPt} alt=""/>),
        pptx: (<img src={aiSourcePPt} alt=""/>),
        pptm: (<img src={aiSourcePPt} alt=""/>),
        pdf: (<img src={aiSourcePPt} alt=""/>),
        // xls: (<img src={xsl} alt=""/>),
        // xlsx: (<img src={xsl} alt=""/>),
        // xlsm: (<img src={xsl} alt=""/>), 
    };

    return (fileIcon[fileType] || (<img src={aiSourceWord} alt=""/>))
}